export default "__VITE_ASSET__B0rDxXw___"